import { Toolbar } from 'components/Toolbar';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, Loader } from 'uikit';
import { formatDateToLocale } from 'utils';

import type { FC } from 'react';

import Styles from './catalogOtherCostTemplates.module.css';

interface ICatalogOtherCostTemplatesToolbar {
    handleCreateOtherCostTemplate: () => void;
    updatedDate: Date;
    catalogUpdatedDateInProgress: boolean;
    catalogOtherCostTemplatesRules: IUseAccess['catalogOtherCostTemplates'];
}

export const CatalogOtherCostTemplatesToolbar: FC<ICatalogOtherCostTemplatesToolbar> = ({
    handleCreateOtherCostTemplate,
    updatedDate,
    catalogUpdatedDateInProgress,
    catalogOtherCostTemplatesRules,
}) => (
    <Toolbar>
        <div className={Styles.ContentToolbar}>
            <Button
                disabled={!catalogOtherCostTemplatesRules.canCreate}
                label="Загрузить шаблон"
                onClick={handleCreateOtherCostTemplate}
                size="s"
                view="secondary"
            />
            {catalogUpdatedDateInProgress ? (
                <div style={{ width: '24px' }}>
                    <Loader />
                </div>
            ) : (
                <span className={Styles.titleTime}>Обновлён: {formatDateToLocale(updatedDate, true)}</span>
            )}
        </div>
    </Toolbar>
);

CatalogOtherCostTemplatesToolbar.displayName = 'CatalogOtherCostTemplatesToolbar';
